var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zv-copyright"},[_c('span',[_vm._v("Copyright © 2020 湖南刺猬安全技术咨询有限公司 All rights reserved.")])])
}]

export { render, staticRenderFns }